// fetchSafe: Timeout + Retry + Measurement (rt_ms)
// ES Module format for Clara360 VPS stability (FIXED: converted from CommonJS)

const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

export async function fetchSafe(url, { timeoutMs = 4000, retries = 1, init = {} } = {}) {
  let lastErr;
  for (let attempt = 0; attempt <= retries; attempt++) {
    const ctl = new AbortController();
    const t0 = Date.now();
    const timer = setTimeout(() => ctl.abort(), timeoutMs);
    try {
      const res = await fetch(url, { ...init, signal: ctl.signal });
      const rt_ms = Date.now() - t0;
      if (!res.ok) throw new Error(`HTTP ${res.status} ${res.statusText}`);
      return { res, rt_ms };
    } catch (e) {
      lastErr = e;
      if (attempt < retries) await sleep(300 + attempt * 500); // Backoff
    } finally {
      clearTimeout(timer);
    }
  }
  throw lastErr;
}

